import React from "react";
import { Card, Col, Row, Statistic, Spin, List, Typography } from "antd";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";
import { useAuth } from "../../contexts/auth.context";
import { UserRole } from "../../types/user.type";

interface MaterialStatsProps {
  data: {
    totalMaterials: number;
    totalAmountUSD: number;
    materials: { name: string; residue: number }[];
  } | null;
  loading: boolean;
}

export default function MaterialStats({ data, loading }: MaterialStatsProps) {
  const { authState } = useAuth();
  if (loading) {
    return <Spin size="large" />;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  return (
    <div style={{ padding: "20px" }}>
      {authState.user?.role !== UserRole.Foreman && (
        <>
          <h2>Материалы Статистика</h2>

          <Row gutter={16}>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Кол-во материалов"
                  value={data.totalMaterials}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Общая сумма (USD)"
                  value={roundToThreeDecimals(data.totalAmountUSD)}
                  prefix="$"
                />
              </Card>
            </Col>
          </Row>
        </>
      )}

      <h3>Список материалов ниже лимита:</h3>
      <div style={{ marginTop: "20px", maxHeight: "300px", overflowY: "auto" }}>
        <List
          dataSource={data.materials}
          renderItem={(item) => (
            <List.Item>
              <Card style={{ width: "100%", background: "red" }}>
                <Typography.Text strong style={{ color: "#fff" }}>
                  {item.name}
                </Typography.Text>
                <div style={{ color: "#fff" }}>
                  Остаток: {roundToThreeDecimals(item.residue)}
                </div>
              </Card>
            </List.Item>
          )}
        />
      </div>
    </div>
  );
}
